import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useCustomNavigation = () => {
  const navigate = useNavigate();

  const back = useCallback(() => navigate(-1), []);
  const forward = useCallback(() => navigate(1), []);

  const push = useCallback((to, state) => navigate(to, { state }), []);

  const replace = useCallback(
    (to, state) => navigate(to, { replace: true, state }),
    [],
  );

  const go = useCallback((delta) => navigate(delta), []);

  return { back, forward, push, replace, go };
};
